<template>
  <div class="camel">
    <svg :viewBox="viewbox"></svg>
  </div>
</template>

<script>
export default {
  data () {
    return {
      viewbox: '0 0 100 100'
    }
  }
}
</script>

<style>

</style>